import React from 'react';
import {
  CalendarModal,
  ReviewDrawer,
  SelectLocationModal,
  UploadCSVModal,
  WelcomeSelectLocationModal,
  SelectFacebookPagesModal,
} from '..';
import SocialPostDetailModal from '@pages/restorgram/SocialPostDetailModal';

type Props = {};

const ModalContainer = (props: Props) => {
  return (
    <React.Fragment>
      <SelectLocationModal />
      <CalendarModal />
      <UploadCSVModal />
      <ReviewDrawer />
      <SocialPostDetailModal />
      <WelcomeSelectLocationModal />
      <SelectFacebookPagesModal />
    </React.Fragment>
  );
};

export default ModalContainer;
